module.exports = global["_"] = require("-!/data/app/rdc-next/node_modules/source-map-loader/index.js!./underscore.js");


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/underscore/underscore.js
// module id = 0
// module chunks = 48 49 50 53